import React, { Component } from "react";
import moment from "moment";
import Media from "react-media";
import { Table, Image, Button } from "react-bootstrap";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { SuggestionDropDownModelPopup } from "../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/superAdminSuggestionDropDownPopup/SuggestionDropDownModelPopup";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  get_vendor_users_tickets,
  update_vendor_users_tickets,
  get_vendor_single_users_tickets,
} from "../../../../store/actions/VendorUsersTicketsActions/vendorUsersTicketsActions";
import isEmpty from "../../../../store/validation/is-Empty";
import store from "../../../../store/store";
import { EDIT_VENDOR_USER_TICKETS_DETAILS } from "../../../../store/types";
import EditOpenIssues from "../../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/InsideAllPageComponent/EditOpenIssues";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import OpenIssuesUsersTableBody from "./OpenIssuesUsersTableBody";
import NoContent from "../../../reusableComponents/NoContentComponent";
const totalRecordsInOnePage = 25;

export class AllOpenIssuesVendorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPagination: 1,
      open: false,
      status: "",
      allUsersTicketsDetails: [],
      search: "",
      id: "",
      loader: false,
      filterOpen: false,
      simpleClick: "All",
      statusFilter: "All",
    };
  }

  componentDidMount() {
    this.props.get_vendor_users_tickets(this.props.auth.user.accessToken);
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.allVendorUsersTickets) !==
      nextState.allUsersTicketsDetails
    ) {
      return {
        allUsersTicketsDetails: !isEmpty(nextProps.allVendorUsersTickets)
          ? nextProps.allVendorUsersTickets
          : [],
      };
    }
    if (!isEmpty(nextProps.auth.loader) !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
  }

  /********************************************
   * @DESC FILTER MODAL FUNCTIONS
   ********************************************/
  onFilterOpen = (e, status, ticketId) => {
    this.setState({
      filterOpen: true,
      status: status,
      id: ticketId,
    });
  };

  onFilterClosed = (e) => {
    this.setState({
      filterOpen: false,
    });
  };

  buttonClickHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      simpleClick: type,
    });
  };

  resetFilterFunc = (e) => {
    this.setState({
      statusFilter: "All",
      simpleClick: "",
      filterOpen: false,
    });
  };

  applyFilterFunc = (e) => {
    this.setState({
      statusFilter: this.state.simpleClick,
      filterOpen: false,
    });
  };

  /*********************************************
   * @DESC Reservation Table Around Time Model
   ********************************************/

  userTicketOpen = (id) => (e) => {
    this.setState({
      open: true,
      id: id,
    });
  };

  userTicketClosed = (e) => {
    this.setState({
      open: false,
      filterOpen: false,
    });
  };

  changeUserTickerStatus = (e) => {
    const token = this.props.auth.user.accessToken;
    const ticketId = this.state.id;
    const formData = {
      status: this.state.status,
    };
    this.props.update_vendor_users_tickets(formData, token, ticketId);
    this.setState({
      open: false,
      filterOpen: false,
    });
  };

  userTicketTextButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({ status: type });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  // sendInformationViewTicket = (data) => (e) => {
  //   this.props.history.push({
  //     pathname: "/viewticketvendoruseropenissue",
  //     state: { vendorUserTickets: data },
  //   });
  // };

  sendInformationViewTicket = (id) => {
    const ticketId = id;
    const token = this.props.auth.user.accessToken;
    this.props.get_vendor_single_users_tickets(
      ticketId,
      token,
      this.onSuccess(ticketId)
    );
  };

  onSuccess = (ticketId) => {
    this.props.history.push({
      pathname: `/viewticketvendoruseropenissue/${ticketId}`,
      state: { vendorUserTickets: ticketId },
    });
  };

  sendInformationEditTicket = (data) => (e) => {
    this.props.history.push({
      pathname: "/editvendoropenticketissue",
      // state: { vendorUserTickets: data },
    });
    store.dispatch({
      type: EDIT_VENDOR_USER_TICKETS_DETAILS,
      payload: data,
    });
  };

  onChangePagination = (page) => {
    // console.log(page);
    this.setState({
      currentPagination: page,
    });
  };

  // DESKTOP
  renderTableDataBody = () => {
    const { allUsersTicketsDetails, currentPagination } = this.state;
    console.log(allUsersTicketsDetails);
    let filtereddata = [];
    if (this.state.statusFilter === "All") {
      filtereddata = allUsersTicketsDetails;
    } else if (this.state.statusFilter === "Walkin") {
      filtereddata = allUsersTicketsDetails.filter(
        (dinner) =>
          dinner.diner_id.isWalkIn === true &&
          dinner.diner_id.service_type === "SEATING"
      );
    } else if (this.state.statusFilter === "Waitlist") {
      filtereddata = allUsersTicketsDetails.filter(
        (dinner) =>
          dinner.diner_id.isWalkIn === false &&
          dinner.diner_id.service_type === "SEATING"
      );
    } else if (this.state.statusFilter === "Reservation") {
      filtereddata = allUsersTicketsDetails.filter(
        (dinner) => dinner.diner_id.service_type === "RESERVATION"
      );
    }
    if (this.props.search) {
      let search = new RegExp(this.props.search, "i");
      filtereddata = allUsersTicketsDetails.filter((getall) => {
        if (search.test(getall.diner_id.user_details.name)) {
          return getall;
        } else if (search.test(getall.seating_request_no)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata?.map(
        (data, index) =>
          index >= (currentPagination - 1) * totalRecordsInOnePage &&
          index < currentPagination * totalRecordsInOnePage && (
            <React.Fragment key={index}>
              <OpenIssuesUsersTableBody
                data={data}
                sendInformationViewTicket={this.sendInformationViewTicket}
                onFilterOpen={this.onFilterOpen}
              />
            </React.Fragment>
          )
      );
    } else {
      return null;
    }
  };

  /*****************************
   @DESC MOBILE
   *****************************/
  renderNewOpenIssuesAccordian = () => {
    const { allUsersTicketsDetails, currentPagination } = this.state;
    console.log(allUsersTicketsDetails);
    let filtereddata = [];
    if (this.state.statusFilter === "All") {
      filtereddata = allUsersTicketsDetails;
    } else if (this.state.statusFilter === "Walkin") {
      filtereddata = allUsersTicketsDetails.filter(
        (dinner) =>
          dinner.diner_id.isWalkIn === true &&
          dinner.diner_id.service_type === "SEATING"
      );
    } else if (this.state.statusFilter === "Waitlist") {
      filtereddata = allUsersTicketsDetails.filter(
        (dinner) =>
          dinner.diner_id.isWalkIn === false &&
          dinner.diner_id.service_type === "SEATING"
      );
    } else if (this.state.statusFilter === "Reservation") {
      filtereddata = allUsersTicketsDetails.filter(
        (dinner) => dinner.diner_id.service_type === "RESERVATION"
      );
    }
    if (this.props.search) {
      let search = new RegExp(this.props.search, "i");
      filtereddata = allUsersTicketsDetails.filter((getall) => {
        if (search.test(getall.diner_id.user_details.name)) {
          return getall;
        } else if (search.test(getall.seating_request_no)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata?.map(
        (data, index) =>
          index >= (currentPagination - 1) * totalRecordsInOnePage &&
          index < currentPagination * totalRecordsInOnePage && (
            <React.Fragment key={index}>
              {/* <SwipeableList className={`swipe`}>
               {({ swipe, ...rest }) => (
                  <div className={`${show ? "swipe" : ""}`}>
                    
                  </div>
               )}
               </SwipeableList> */}
              <Card className="main-reusable-accordion">
                <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                  <div className="d-flex align-items-center">
                    <div className="card-header-left f10-500">
                      #{data?.ticket_number}
                    </div>
                    <div className="card-header-middle f10-500">
                      {data?.seating_request_no}
                    </div>
                    <div className="card-header-middle ml-2 f10-500">
                      {data?.description}
                    </div>
                    <div className="card-header-right f10-500 justify-content-center">
                      {" "}
                      {data?.status === 0
                        ? "New"
                        : data?.status === 1
                        ? "In-Progress"
                        : data?.status === 2
                        ? "Awaiting - Feedback"
                        : data?.status === 3
                        ? "On-Hold"
                        : data?.status === 4
                        ? "ReOpened"
                        : data?.status === 5
                        ? "Resolved"
                        : data?.status === 6
                        ? "Closed"
                        : data?.status === 7
                        ? "Archive"
                        : data?.status === 8
                        ? "Called User"
                        : data?.status === 9
                        ? "Completed"
                        : ""}
                    </div>
                  </div>{" "}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={index + 1}>
                  <Card.Body>
                    {/******* Section One *********/}
                    <hr className="mt-0" />
                    <div className="row">
                      <div className="col-4 sectionone-left">
                        <p className="f10-700 pb-2 opacity5">User Name</p>
                        {/* <p className="f10-400">{seatingPreference}</p> */}
                        <div className="d-flex super-admin-suggestion-table-body-boxone align-items-center">
                          <div className="super-admin-suggestion-imageBoxOne enIMG33 mr-2">
                            <Image
                              fluid
                              src={
                                data?.user_id === null
                                  ? require("../../../../assets/images/ActionImages/demoprofile.jpg")
                                  : data?.user_id?.profile_photo[0] ||
                                    data?.user_id?.profile_photo?.length === 1
                                  ? data?.user_id?.profile_photo[0]
                                  : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                              }
                              className="rounded-circle"
                              alt="Icon"
                            />
                          </div>
                          <div className="super-admin-suggestion-imageBoxTwo ">
                            <div className="f12-400">
                              {data &&
                                data?.diner_id &&
                                data?.diner_id.user_details.name}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-4 sectionone-middle ">
                        <p className="f10-700 pb-2 opacity5">Ticket Date</p>
                        <div className="f10-400 align-items-center">
                          {/* <div className="f12-400"> */}
                          {moment(data?.createdAt).format("DD-MM-YYYY")}
                          {/* </div> */}
                        </div>
                      </div>
                      <div className="col-4 sectionone-right ">
                        <p className="f10-700 pb-2 opacity5">Actions</p>
                        <div className="d-flex align-items-center mt-3">
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              this.sendInformationViewTicket(data._id)
                            }
                          >
                            <Image
                              fluid
                              alt="View"
                              title="View"
                              src={require("../../../../assets/images/UserManagement/eye.svg")}
                            />
                          </Button>
                          <EditOpenIssues issueDetail={data} />
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </React.Fragment>
          )
      );
    } else {
      return <NoContent/>;
    }
  };
  render() {
    if (this.props.auth.loader === true) {
      return <AmealioLoader />;
    } else {
      return (
        <React.Fragment>
          <Media query="(max-width: 991px)">
            <>
              <div className="row seating-dashboard-table">
                <div className="col-3 mpr-1">
                  <p className="f12-700 pl-3">Sr. No</p>
                </div>
                <div className="col-3 mpl-1 mpr-1">
                  <p className="f12-700">Request ID</p>
                </div>
                <div className="col-3 mpl-1">
                  <p className="f12-700">Issue</p>
                </div>
                <div className="col-3 mpl-1">
                  <p className="f12-700">Status</p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 p-0">
                  <Accordion>{this.renderNewOpenIssuesAccordian()}</Accordion>
                </div>
              </div>
            </>
          </Media>
          <Media query="(min-width: 991px)">
            <div className="user-table-reusable-superadmin table-responsive">
              <Table className="enOpenTicketsUsers HideShowTable">
                <thead>
                  <tr className="super_admin_all_users_table_head">
                    <th className="f12-700" style={{ width: "10%" }}>
                      Ticket Number
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Request Number
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      User name
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Issue Type
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Issue Category
                    </th>
                    <th className="f12-700" style={{ width: "18%" }}>
                      Issue Description
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Status
                    </th>
                    <th className="f12-700" style={{ width: "10%" }}>
                      Ticket Date/ Time
                    </th>
                    <th className="f12-700" style={{ width: "12%" }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                {this.renderTableDataBody()}
              </Table>
            </div>
          </Media>
          <div className="p4v2-menu-pagination">
            <Pagination
              onChange={this.onChangePagination}
              current={this.state.currentPagination}
              defaultPageSize={totalRecordsInOnePage}
              total={
                !isEmpty(this.state.allUsersTicketsDetails)
                  ? this.state.allUsersTicketsDetails.length
                  : 0
              }
              showTitle={false}
            />
          </div>
          {this.state.filterOpen ? (
            <SuggestionDropDownModelPopup
              //onOpenModal={this.userTicketOpen(data?._id)}
              open={this.state.filterOpen}
              onCloseModal={this.userTicketClosed}
              buttonTitle="Suggestion Status"
              buttonText="Suggestion Status"
              headerText="Suggestion Status"
              displayButtonThree={false}
              displayButtonFour={true}
              displayButtonFive={true}
              displayButtonSix={false}
              status={this.state.status}
              //status={data?.status}
              timeTextOne="New"
              timeTextTwo="In-Progress"
              timeTextThree="Awaiting - Feedback"
              timeTextFour="On-Hold"
              timeTextFive="ReOpened"
              timeTextSix="Resolved"
              // timeTextSeven="Closed"
              timeTextEight="Archive"
              timeTextNine="Called User"
              // timeTextTen="Completed"
              timeOneClick={(e) => this.userTicketTextButtonClick(e, 0)}
              timeTwoClick={(e) => this.userTicketTextButtonClick(e, 1)}
              timeThreeClick={(e) => this.userTicketTextButtonClick(e, 2)}
              timeFourClick={(e) => this.userTicketTextButtonClick(e, 3)}
              timeFiveClick={(e) => this.userTicketTextButtonClick(e, 4)}
              timeSixClick={(e) => this.userTicketTextButtonClick(e, 5)}
              timeSevenClick={(e) => this.userTicketTextButtonClick(e, 6)}
              timeEightClick={(e) => this.userTicketTextButtonClick(e, 7)}
              timeNineClick={(e) => this.userTicketTextButtonClick(e, 8)}
              timeTenClick={(e) => this.userTicketTextButtonClick(e, 9)}
              onSubmit={() => this.changeUserTickerStatus()}
            />
          ) : (
            <> </>
          )}
        </React.Fragment>
      );
    }
  }
}

AllOpenIssuesVendorDashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allVendorUsersTickets: state.vendorUsersTickets.vendor_all_users_tickets,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_vendor_users_tickets,
  update_vendor_users_tickets,
  get_vendor_single_users_tickets,
})(withRouter(AllOpenIssuesVendorDashboard));
